import type { BrandSetCheck } from "@/interfaces/selections/selections.types";
import type { SelectionsRefOrigin } from "@/utils/selections/buildValidateRequest";

export interface OwnedBrandRefs {
  brands: string[];
  secondaryBrands: string[];
}

/**
 * For usable (OWNED / ALREADY_HAVE) shared brand sets, resolve the ULID the caller actually
 * owns — the source itself when OWNED, or the caller's own copy (existingUlid) when
 * ALREADY_HAVE — and route it back to the selection field the shared source came from, so a
 * set the recipient already has is silently re-selected as their own.
 */
export function resolveOwnedBrandRefs(
  usableBrandSets: BrandSetCheck[],
  origin: SelectionsRefOrigin,
): OwnedBrandRefs {
  const brands: string[] = [];
  const secondaryBrands: string[] = [];
  for (const check of usableBrandSets) {
    const owned = check.existingUlid ?? check.ulid;
    const bucket =
      origin.brandSetOrigin[check.ulid] === "secondaryBrands"
        ? secondaryBrands
        : brands;
    if (!bucket.includes(owned)) bucket.push(owned);
  }
  return { brands, secondaryBrands };
}
